import { Injectable } from "@angular/core";
import { PropertyMetadata, IGridViewMetadata } from "@tylertech/tyler-api-types";
import { MetadataPropertyService } from "../metadataPropertyService";
import { MetadataInputTypeHelperService } from "../metadataInputTypeHelperService";
import { MetadataValidationService } from "../metadataValidationService";
import { MetadataViewService } from "../metadataViewService";
import { ProviderStorageService } from "./provider.storage.service";
import { CellEditService } from "./cellEdit.service";
import { Observable, Subject } from "rxjs";
import { Utilities } from "@tylertech/shared-module";
import { AugmentedPropertyMetadata } from "../../interfaces";

@Injectable({ providedIn: "root" })
export class GridValidationService
{
    private readonly validateCellGridSubject$ = new Subject<void>();
    get validateCellGrid(): Observable<void>
    {
        return this.validateCellGridSubject$.asObservable();
    }

    constructor(
        private $metadataInputTypeHelperService: MetadataInputTypeHelperService,
        private $metadataPropertyService: MetadataPropertyService,
        private $metadataValidationService: MetadataValidationService,
        private $metadataViewService: MetadataViewService,
        private $providerStorageService: ProviderStorageService,
        private $cellEditService: CellEditService
    ) { }

    triggerValidateCellGrid(): void
    {
        this.validateCellGridSubject$.next();
    }

    validateCellEditGrid(providerId: string, viewMetadata: IGridViewMetadata, cellEditing: boolean): void
    {
        if (!this.$metadataViewService.IsCellEditGrid(viewMetadata) || cellEditing)
            return;
        const rows = this.$providerStorageService.GridData[viewMetadata.GridProperties["$providerId"]];
        rows.forEach(row =>
        {
            const model = row["$$model"];
            viewMetadata.GridProperties.ClassMetadata.Properties.forEach((prop: AugmentedPropertyMetadata) =>
            {
                if (model.$errors)
                    delete model.$errors[prop.Name];
                prop.$$formControlError = undefined;
                let invalid = this.isCellInvalid(prop, model);
                this.$cellEditService.SetCellEditValidity(providerId, model, prop.Name, invalid);
                this.$cellEditService.SetCellEditErrors(model);
            });
        });
    }

    isCellInvalid(propertyMetadata: PropertyMetadata, model: any): boolean
    {
        const viewOnly = this.$metadataPropertyService.isViewOnly(propertyMetadata, model, model["$$Parent"]);
        if (viewOnly)
            return false;
        const value = model[propertyMetadata.Name];

        const maxLength = this.$metadataInputTypeHelperService.getMaxLength(propertyMetadata, model, model["$$Parent"]);
        if (maxLength && value?.length > propertyMetadata.MaxLength)
            return true;

        if (this.$metadataInputTypeHelperService.isNumeric(propertyMetadata.InputType) || propertyMetadata.InputType === "Currency" || propertyMetadata.InputType === "Percent")
        {
            if (this.$metadataPropertyService.isRequired(propertyMetadata, model, model["$$Parent"]) && Utilities.IsNullOrUndefined(value))
                return true;
            const maxValue = this.$metadataInputTypeHelperService.getMaxValue(propertyMetadata, model, model["$$Parent"]);
            if (!this.$metadataValidationService.validateMaximumAmount(value?.toString(), false, maxValue, () => this.$metadataValidationService.genericParse(value.toString())))
                return true;

            const minValue = this.$metadataInputTypeHelperService.getMinValue(propertyMetadata, model, model["$$Parent"]);
            if (!this.$metadataValidationService.validateMinimumAmount(value?.toString(), false, minValue, () => this.$metadataValidationService.genericParse(value.toString())))
                return true;

            const precision = this.$metadataInputTypeHelperService.getPrecision(propertyMetadata, model, model["$$Parent"]);
            if (!this.$metadataValidationService.validatePrecision(value?.toString(), false, precision))
                return true;

            const scale = this.$metadataInputTypeHelperService.getScale(propertyMetadata, model, model["$$Parent"]);
            if (!this.$metadataValidationService.validateScale(value?.toString(), false, scale))
                return true;
        }
        else
        {
            if (this.$metadataPropertyService.isRequired(propertyMetadata, model, model["$$Parent"]) && !value)
                return true;
        }

        // if ("pattern" in $error)
        // {
        //     if (
        //         this.$metadataInputTypeHelperService.isPhoneNumber(this.inputType) ||
        //         this.$metadataInputTypeHelperService.isPhoneNumberWithExtension(this.inputType)
        //     )
        //     {
        //         msg = "Please enter a valid phone number";
        //     }
        //     else
        //     {
        //         msg = `${this.Label} does not match the expected format`;
        //     }
        // }
        // if ("compareTo" in $error)
        // {
        //     if (this.errorMessages.length > 0)
        //     {
        //         for (let i = 0, l = this.errorMessages.length; i < l; i++)
        //         {
        //             msg += this.errorMessages[i].value;
        //             if (i + 1 < l)
        //             {
        //                 msg += "\n";
        //             }
        //         }
        //     }
        // }
    }
}
